export default __webpack_public_path__ + "static/media/svg-ProcessManager.2eeb52dd.svg";